/**
 * @Function 图片渐进式懒加载  源码
 * @Author 郗子硕
 * @Date 2021-10-21
 */

const EVENTS = ['scroll', 'wheel', 'mousewheel', 'resize'];
console.log("coming in imglazyloading");
/**
 * @Function 工具函数
 */
const Util = {
  /**
   * @Function 
   * @params action -> checkImage()方法
   * @params delay 毫秒数
   */
  throttle(action, delay) {
    let timeout = null;
    let lastRun = 0;
    return function () {
      if (timeout) {
        return;
      }
      const elapsed = Date.now() - lastRun;
      const context = this;
      const args = arguments;
      const runCallback = function () {
        lastRun = Date.now();
        timeout = false;
        action.apply(context, args);
      }
      if (elapsed >= delay) {
        runCallback();
      } else {
        timeout = setTimeout(runCallback, delay);
      }
    }
  },
  /**
   * @Function 开启监听
   */
  on(el, ev, fn) {
    el.addEventListener(ev, fn);
  },
  /**
   * @Function 移除监听
   */
  off(el, ev, fn) {
    el.removeEventListener(ev, fn);
  },
}

/**
 * @Function  控制window 监听方法   增加监听方法  或者  移除监听方法
 * @el  ->  window
 * @bind  ->  Boolean
 */
const events = (el, bind) => {
  if (bind) {
    EVENTS.forEach(evt => {
      Util.on(el, evt, lazy);
    });
  } else {
    EVENTS.forEach(evt => {
      Util.off(el, evt, lazy);
    });
  }
}



const lazy = Util.throttle(() => {
  checkImage();
}, 300);


/*
 * 
 */
let windowHasBindEvents = false;
// 自执行方法
checkImage();

function checkImage() {

  // 开启监听
  if (!windowHasBindEvents) {
    // 以防下次进入checkImage()方法，重复开启监听
    windowHasBindEvents = true;
    // 开启监听
    events(window, true);
  }

  // 获取所有图片懒加载的 img标签DOM
  const lazys = document.querySelectorAll('img.lazy');
  // 是否有DOM断言
  if (lazys.length > 0) {
    // 遍历img标签所有的DOM
    for (let i = 0; i < lazys.length; i++) {
      // 获取该DOM在网页的区域
      const rect = lazys[i].getBoundingClientRect(); //DOMRect {x: 103.5, y: 0, width: 1200, height: 576, top: 0, …}
      // 时候在当前窗口
      if (rect.top < window.innerHeight && rect.bottom > 0 && rect.left < window.innerWidth && rect.right > 0) {
        // 加载图片
        loadImage(lazys[i]);
      }
    }
  } else {
    // lazys dom没有了  
    // 下次进入checkImage()方法， 以便开启监听
    windowHasBindEvents = false;
    // 移除监听
    events(window, false);
  }
}

/**
 * @Fucntion 加载data-src属性中的图片
 * @item img dom
 */
function loadImage(item) {
  // 创建Image实例
  const img = new Image();
  // 断言--------------????????--------------
  if (item.dataset) {
    item.dataset.srcset && (img.srcset = item.dataset.srcset);
    item.dataset.sizes && (img.sizes = item.dataset.sizes);
  }
  // 真实大图 item.dataset.src;
  img.src = item.dataset.src;
  // 加入origin类名
  img.className = 'origin';
  // 加载成功后处理
  img.onload = () => {
    // 移出lazy 类名
    item.classList.remove('lazy');
    // 挂载图片
    mountImage(item, img);
  }
}

/**
 * @Fucntion 挂载图片方法
 * @preview img dom
 * @img new Image() 实例
 */
function mountImage(preview, img) {
  // 返回img标签 的父节点   如果没有返回null
  const parent = preview.parentNode;
  // 应该断言有没有  父节点   判断是否为null
  //  -------------to...do...-------------
  // -------------------------------------------------------------------------------------------------
  //
  // (-----!!!!!!!!-----)  { 这是显示data-src里的图片路径 }   img已经带有data-src主图片
  // dom.appendChild(node) 在dom下添加一个子节点
  // addEventListener('animationend' fn()) 触发动画
  // Chrome, Safari 和 Opera 代码 webkitAnimationEnd
  // 标准语法 animationend
  // 有病的逻辑吧  css已经有了动画 为什么还要动画效果呢
  parent.appendChild(img).addEventListener('animationend', e => {
    // console.log(e);
    // 移出渐变效果
    preview.classList.remove('origin');
    //移植alt属性
    e.target.alt = preview.alt || '';
    // 
    preview.classList.add('hide');
    // parent.removeChild(preview);
    // e.target.classList.remove('origin');
  });
  //
  //4e45
  // -------------------------------------------------------------------------------------------------
}